var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorselector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_selector",
    "data-name": "Color selector",
    transform: "translate(15576 16479)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5317",
    "data-name": "Rectangle 5317",
    width: 20,
    height: 20,
    transform: "translate(-15576 -16479)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color-picker-svgrepo-com",
    transform: "translate(-15575.02 -16477.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65150",
    "data-name": "Group 65150",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34309",
    "data-name": "Path 34309",
    d: "M15.308,4.434A2.515,2.515,0,0,0,15.079.9,2.516,2.516,0,0,0,11.545.67L10.364,1.853l3.764,3.764,1.18-1.183Z",
    fill: "#f60",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34310",
    "data-name": "Path 34310",
    d: "M5.468,14.276l6.147-6.148.772.772,1.584-1.586L8.662,2.005,7.077,3.589l.773.773L1.7,10.508.02,15.2l.754.754,4.694-1.679ZM8.916,5.428l1.635,1.636-6.262,6.26-2.594.96.959-2.6,6.262-6.26Z",
    fill: "#f60",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorselector);
export default __webpack_public_path__ + "static/media/Color selector.800930fefb2435620ea387fdd36ba478.svg";
export { ForwardRef as ReactComponent };